import { Step } from '@/util/Step';
import { PaymentMethodDto } from '@/api';

export const delivery = {
  type: {
    pickUp: 'Pick up',
    delivery: 'Delivery',
  },
  pickupExplainer: {
    wrapper: 'Please select when you want to pick up your order {location}. ' +
      'This time frame determines the earliest possible pick-up time. You can pick up your order ' +
      'until {deadline} on the selected day.',
    hidden: 'Show explanation',
  },
  header: {
    pickUp: 'in',
    delivery: 'to',
    summary: ' {location}, {time}',
    deadlineLabel: 'Order until',
    deadlineCloseLabel: 'Order in the next',
    deadlineCloseMinutes: '{minutes} minutes',
    selectLine1: 'Please',
    selectLine2: 'select',
  },
};

export const order = {
  step: {
    [Step.ADDRESS]: 'Billing & delivery address',
    [Step.DELIVERY]: 'Delivery',
    [Step.PAYMENT]: 'Payment',
    [Step.SUMMARY]: 'Summary',
  },
  actionComplete: 'Order with obligation to pay',
  actionNext: 'Continue',
  cardHolderError: 'Invalid card holder',
  address: {
    newAddress: 'Add a new address',
    noAddresses: 'Your account does not have any address associated. Please add an address in your profile before ' +
      'you submit your order.',
    goToProfile: 'Add address',
    sameAddress: 'The delivery address is the same as the billing address',
    alternativeAddress: 'Choose an alternative delivery address',
    changeAddress: 'Change Address',
    doneChange: 'Done',
  },
  paymentMethod: {
    [PaymentMethodDto.CASH]: 'Payment at pick-up or delivery. Cash or card payment possible',
    [PaymentMethodDto.PAYPAL]: 'PayPal',
    [PaymentMethodDto.CREDITCARD]: 'Credit card',
    [PaymentMethodDto.SOFORT]: 'Sofort debit',
  },
  transaction: {
    descriptions: {
      creditCard: 'Payment by credit card',
      paypal: 'Payment with PayPal. \n' +
      'By clicking on the button you will be automatically redirected to PayPal. ' +
        'Log in directly to your PayPal account and confirm the payment.',
      sofort: 'Payment with Sofort',
      error: 'Sorry, an error has occurred. Please return to the previous page and repeat your selection',
    },
    price: 'Payment amount: {price} €',
    cancelHeader: 'Cancel transaction',
    cancelDescription: 'You\'re sure you want to cancel the transaction?',
  },
  delivery: {
    header: 'Delivery',
    delivery: 'Delivery',
    pickup: 'Pickup',
    chooseDelivery: 'Choose delivery method',
    place: 'City',
    deliveryPlace: 'Delivery to',
    chooseDeliverySlot: 'Choose your delivery slot.',
    choosePickupSlot: 'Choose your pickup slot.',
    notInDeliveryArea: 'Your postcode is currently not available in our delivery area - please choose the pickup method.',
    noPostCode: 'Please enter your post code above to see available delivery slots.',
    driverNotice: 'Note to delivery driver',
    driverNoticePlaceholder: 'Bell broken, please knock on front door',
    myAddresses: 'My Addresses',
    select: 'Select',
    calendar: {
      today: 'today',
      tomorrow: 'tomorrow',
      now: 'Now',
      weekday: {
        1: 'Monday',
        2: 'Tuesday',
        3: 'Wednesday',
        4: 'Thursday',
        5: 'Friday',
        6: 'Saturday',
        7: 'Sunday',
      },
    },
  },
  confirmation: {
    thankYouNote: 'Thank you for your order!',
    emailNote: 'You will soon receive a confirmation mail.',
    orderNumber: 'Your order number is',
    failed: 'An error occured during checkout.',
    retry: 'Try again',
    askCustomerService: 'Or contact the customer service.',
  },
  summary: {
    header: 'Summary',
    billingAddress: 'Billing address',
    mailTo: 'Confirmation mail to',
    telephone: 'Telephone',
    deliveryAddress: 'Delivery address',
    paymentMethod: 'Payment method',
  },
};
